<template>
  <div data-component-name="ArticlePreview">
    <ArticlePreviewDefault v-if="type === DEFAULT" :article />

    <ArticlePreviewDefaultSettings v-if="type === DEFAULT_SETTINGS" :article />

    <ArticlePreviewPicture v-if="type === WITH_PICTURE" :article />
  </div>
</template>

<script setup lang="ts">
import { PostPreviewType, type BlogArticle } from '~/types';

// components
import ArticlePreviewDefault from './ArticlePreviewDefault.vue';
import ArticlePreviewPicture from './ArticlePreviewPicture.vue';
import ArticlePreviewDefaultSettings from './ArticlePreviewDefaultSettings.vue';

defineOptions({
  components: {
    ArticlePreviewDefault,
    ArticlePreviewPicture,
    ArticlePreviewDefaultSettings,
  },
});

const { DEFAULT, DEFAULT_SETTINGS, WITH_PICTURE } = PostPreviewType;

const props = defineProps<{ article: BlogArticle }>();
const type = computed(() => props.article.data?.data?.preview_type);
</script>

<style scoped lang="scss">
[data-component-name='ArticlePreview'] {
  width: 100%;
}
</style>
